import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemShippingInsuranceMaybe = props => {
  const { lineItems, intl } = props;

  const shippingInsuranceLineItem = lineItems.find(
    item => item.code === 'line-item/shipping-insurance' && !item.reversal
  );

  return shippingInsuranceLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="LineItemShippingInsuranceMaybe.shippingInsurance" />
      </span>
      <span className={css.itemValue}>
        {formatMoney(intl, shippingInsuranceLineItem.lineTotal)}
      </span>
    </div>
  ) : null;
};

LineItemShippingInsuranceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemShippingInsuranceMaybe;
